// Importaciones necesarias
import React from "react";
import styled from "styled-components";
import WhatsAppIcon from "@mui/icons-material/WhatsApp"; // Importa el ícono de MUI

function Redirect(){
    function esDispositivoMovil() {
        return window.innerWidth <= 768;
    }
    
    if (esDispositivoMovil()) {
        window.location.href = "https://wa.link/a6vmqb";
    } else {
      window.location.href = "https://web.whatsapp.com/send?phone=573107336975&text=%C2%A1Hola!%20Estoy%20interesado%20en%20una%20bicicleta";
    }
}
// Estilos del botón utilizando styled-components
const WhatsAppButtons = styled.a`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  z-index: 1000;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
    color: #fff;
    cursor: pointer;
  }

  &:active {
    transform: scale(0.9);
  }
`;

// Componente principal
export const WhatsAppButton = () => {
  return (
    <WhatsAppButtons
      onClick={Redirect}
      target="_blank"
      rel="noopener noreferrer"
    >
      <WhatsAppIcon style={{ fontSize: 30 }} /> {/* Uso del ícono de MUI */}
    </WhatsAppButtons>
  );
};
